import { utf16Length } from "./string-validation"
import { z } from "zod"

export const TELEHEALTH_CANCELLATION_REASON_MAX_LENGTH = 500

function containsAsciiControlCharacter(value: string): boolean {
	for (const character of value) {
		const codePoint = character.codePointAt(0)
		if (codePoint !== undefined && (codePoint <= 0x1f || codePoint === 0x7f)) return true
	}
	return false
}

export function isSafeTelehealthVisitAccessUrl(value: string): boolean {
	if (containsAsciiControlCharacter(value)) return false
	try {
		const url = new URL(value)
		return url.protocol === "https:" && url.username.length === 0 && url.password.length === 0
	} catch {
		return false
	}
}

export function isSupportedPatientTimezone(value: string): boolean {
	try {
		new Intl.DateTimeFormat("en-US", { timeZone: value }).format(0)
		return true
	} catch {
		return false
	}
}

export const TelehealthVisitAccessUrlSchema = z
	.string()
	.trim()
	.min(1)
	.refine(isSafeTelehealthVisitAccessUrl, "Visit access URL must be a credential-free HTTPS URL.")
	.meta({ id: "TelehealthVisitAccessUrl" })

export const PatientTimezoneSchema = z
	.string()
	.trim()
	.min(1)
	.apply(utf16Length("max", 100))
	.refine(isSupportedPatientTimezone, "Patient timezone must be a supported IANA timezone.")
	.meta({ id: "PatientTimezone" })

export const TelehealthCancellationReasonSchema = z
	.string()
	.trim()
	.min(1, "Enter a reason for cancellation.")
	.apply(utf16Length("max", TELEHEALTH_CANCELLATION_REASON_MAX_LENGTH, `Cancellation reason must be ${TELEHEALTH_CANCELLATION_REASON_MAX_LENGTH} characters or fewer.`))
	.meta({ id: "TelehealthCancellationReason" })
